import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", null, "AUTO Renewal Coverage Form", -1)
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_new_address_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_new_address_header",
  "data-kt-scroll-wrappers": "#kt_modal_new_address_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6" }
const _hoisted_10 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createVNode("h4", { class: "text-gray-800 fw-bolder" }, "Confirmation"),
    /*#__PURE__*/_createVNode("div", { class: "fs-6 text-gray-600" }, " The information below will be used in automatically renewing your coverage. Please take not that your account will automatically be deducted with the amount for Bronze coverage + 10% tax and processing FEE. ")
  ])
], -1)
const _hoisted_12 = { class: "w-100" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "pb-10 pb-lg-15" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Below are the details for your Insurance coverage ")
], -1)
const _hoisted_14 = { class: "row mb-10" }
const _hoisted_15 = { class: "col-md-6 fv-row" }
const _hoisted_16 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Your First Name"
  })
], -1)
const _hoisted_18 = { class: "position-relative" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-md-6 fv-row" }
const _hoisted_22 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", null, "Middle Name")
], -1)
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "col-md-6 fv-row" }
const _hoisted_27 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_28 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Last Name", -1)
const _hoisted_29 = { class: "position-relative" }
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "col-md-6 fv-row" }
const _hoisted_33 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_34 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Birth Date", -1)
const _hoisted_35 = { class: "position-relative" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-md-6 fv-row" }
const _hoisted_39 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_40 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Country of Nationality", -1)
const _hoisted_41 = { class: "position-relative" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "col-md-6 fv-row" }
const _hoisted_45 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_46 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Job Classification", -1)
const _hoisted_47 = { class: "position-relative" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-10" }
const _hoisted_51 = { class: "col-md-6 fv-row" }
const _hoisted_52 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Mobile Number", -1)
const _hoisted_54 = { class: "position-relative" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "col-md-6 fv-row" }
const _hoisted_58 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_59 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Email", -1)
const _hoisted_60 = { class: "position-relative" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "pb-3 pb-lg-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Your address ")
], -1)
const _hoisted_64 = { class: "col-md-6 fv-row" }
const _hoisted_65 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_66 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Block Number and Street", -1)
const _hoisted_67 = { class: "position-relative" }
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = { class: "col-md-6 fv-row" }
const _hoisted_71 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_72 = /*#__PURE__*/_createVNode("label", { class: "fs-6 fw-bold form-label mb-2" }, "Name of Building(Optional)", -1)
const _hoisted_73 = { class: "position-relative" }
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = { class: "col-md-6 fv-row" }
const _hoisted_77 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_78 = /*#__PURE__*/_createVNode("label", { class: " fs-6 fw-bold form-label mb-2" }, "Unit Number (Optional)", -1)
const _hoisted_79 = { class: "position-relative" }
const _hoisted_80 = { class: "fv-plugins-message-container" }
const _hoisted_81 = { class: "fv-help-block" }
const _hoisted_82 = { class: "col-md-6 fv-row" }
const _hoisted_83 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "City", -1)
const _hoisted_85 = { class: "position-relative" }
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }
const _hoisted_88 = { class: "col-md-6 fv-row" }
const _hoisted_89 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_90 = /*#__PURE__*/_createVNode("label", { class: " fs-6 fw-bold form-label mb-2" }, "Postal Code", -1)
const _hoisted_91 = { class: "position-relative" }
const _hoisted_92 = { class: "fv-plugins-message-container" }
const _hoisted_93 = { class: "fv-help-block" }
const _hoisted_94 = { class: "col-md-6 fv-row" }
const _hoisted_95 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_96 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Country", -1)
const _hoisted_97 = { class: "position-relative" }
const _hoisted_98 = { class: "fv-plugins-message-container" }
const _hoisted_99 = { class: "fv-help-block" }
const _hoisted_100 = { class: "col-md-6 fv-row" }
const _hoisted_101 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_102 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Province", -1)
const _hoisted_103 = { class: "position-relative" }
const _hoisted_104 = { class: "fv-plugins-message-container" }
const _hoisted_105 = { class: "fv-help-block" }
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { class: "pb-3 pb-lg-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-gray-400 fw-bold fs-6" }, " Beneficiary Details ")
], -1)
const _hoisted_107 = { class: "row mb-10" }
const _hoisted_108 = { class: "col-md-6 fv-row" }
const _hoisted_109 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_110 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Beneficiary First Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Beneficiary First Name"
  })
], -1)
const _hoisted_111 = { class: "fv-plugins-message-container" }
const _hoisted_112 = { class: "fv-help-block" }
const _hoisted_113 = { class: "col-md-6 fv-row" }
const _hoisted_114 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_115 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createVNode("span", { class: "required" }, "Beneficiary Middle Name"),
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Beneficiary Middle Name"
  })
], -1)
const _hoisted_116 = { class: "fv-plugins-message-container" }
const _hoisted_117 = { class: "fv-help-block" }
const _hoisted_118 = { class: "col-md-6 fv-row" }
const _hoisted_119 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_120 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Last Name", -1)
const _hoisted_121 = { class: "position-relative" }
const _hoisted_122 = { class: "fv-plugins-message-container" }
const _hoisted_123 = { class: "fv-help-block" }
const _hoisted_124 = { class: "col-md-6 fv-row" }
const _hoisted_125 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_126 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Birth Date", -1)
const _hoisted_127 = { class: "position-relative" }
const _hoisted_128 = { class: "fv-plugins-message-container" }
const _hoisted_129 = { class: "fv-help-block" }
const _hoisted_130 = { class: "col-md-6 fv-row" }
const _hoisted_131 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_132 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Beneficiary Mobile Number", -1)
const _hoisted_133 = { class: "position-relative" }
const _hoisted_134 = { class: "fv-plugins-message-container" }
const _hoisted_135 = { class: "fv-help-block" }
const _hoisted_136 = { class: "col-md-6 fv-row" }
const _hoisted_137 = { class: "d-flex flex-column mb-7 fv-row" }
const _hoisted_138 = /*#__PURE__*/_createVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Relationship With Insured", -1)
const _hoisted_139 = { class: "position-relative" }
const _hoisted_140 = /*#__PURE__*/_createVNode("option", null, "Select Relationship", -1)
const _hoisted_141 = /*#__PURE__*/_createVNode("option", {
  label: "Spouse",
  value: "Spouse"
}, "Spouse", -1)
const _hoisted_142 = /*#__PURE__*/_createVNode("option", {
  label: "Child",
  value: "Child"
}, "Child", -1)
const _hoisted_143 = /*#__PURE__*/_createVNode("option", {
  label: "Parent",
  value: "Parent"
}, "Parent", -1)
const _hoisted_144 = /*#__PURE__*/_createVNode("option", {
  label: "Sibling",
  value: "Sibling"
}, "Sibling", -1)
const _hoisted_145 = /*#__PURE__*/_createVNode("option", {
  label: "Others (Blood-related, Relative)",
  value: "Others"
}, "Others (Blood-related, Relative)", -1)
const _hoisted_146 = { class: "fv-plugins-message-container" }
const _hoisted_147 = { class: "fv-help-block" }
const _hoisted_148 = { class: "modal-footer flex-center" }
const _hoisted_149 = {
  ref: "submitButtonRef",
  type: "button",
  id: "kt_modal_new_address_submit",
  class: "btn btn-primary"
}
const _hoisted_150 = { key: 1 }
const _hoisted_151 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_152 = /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock("div", {
    class: "modal fade",
    id: _ctx.sealpro_encode_modal,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_new_address_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                ])
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
                  ]),
                  _hoisted_11
                ]),
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode("div", _hoisted_18, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_firstName",
                            modelValue: _ctx.insured_firstName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.insured_firstName = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_19, [
                            _createVNode("div", _hoisted_20, [
                              _createVNode(_component_ErrorMessage, { name: "insured_firstName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "insured_middleName",
                          modelValue: _ctx.insured_middleName,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.insured_middleName = $event)),
                          maxlength: "50"
                        }, null, 8, ["modelValue"]),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _createVNode(_component_ErrorMessage, { name: "insured_middleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode("div", _hoisted_29, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_lastName",
                            modelValue: _ctx.insured_lastName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.insured_lastName = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_30, [
                            _createVNode("div", _hoisted_31, [
                              _createVNode(_component_ErrorMessage, { name: "insured_lastName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode("div", _hoisted_35, [
                          _createVNode(_component_Field, {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_birthday",
                            modelValue: _ctx.insured_birthday,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.insured_birthday = $event)),
                            value: _ctx.insured_birthday,
                            onBlur: _cache[5] || (_cache[5] = ($event: any) => {_ctx.blurBirthdate($event);})
                          }, null, 8, ["modelValue", "value"]),
                          _createVNode("div", _hoisted_36, [
                            _createVNode("div", _hoisted_37, [
                              _createVNode(_component_ErrorMessage, { name: "insured_birthday" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode("div", _hoisted_41, [
                          _createVNode(_component_Field, {
                            name: "address_country2",
                            modelValue: _ctx.address_country2,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.address_country2 = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countries) + " ", 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.country_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _createVNode(_component_ErrorMessage, { name: "address_country2" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createVNode("div", _hoisted_47, [
                          _createVNode(_component_Field, {
                            name: "job_classification",
                            modelValue: _ctx.job_classification,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.job_classification = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.job_classification_options_list, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.name
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_48, [
                            _createVNode("div", _hoisted_49, [
                              _createVNode(_component_ErrorMessage, { name: "job_classification" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_50, [
                    _createVNode("div", _hoisted_51, [
                      _createVNode("div", _hoisted_52, [
                        _hoisted_53,
                        _createVNode("div", _hoisted_54, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_mobileNumber",
                            modelValue: _ctx.insured_mobileNumber,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.insured_mobileNumber = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_55, [
                            _createVNode("div", _hoisted_56, [
                              _createVNode(_component_ErrorMessage, { name: "insured_mobileNumber" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createVNode("div", _hoisted_60, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "insured_email",
                            modelValue: _ctx.insured_email,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.insured_email = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_61, [
                            _createVNode("div", _hoisted_62, [
                              _createVNode(_component_ErrorMessage, { name: "insured_email" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_63,
                    _createVNode("div", _hoisted_64, [
                      _createVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createVNode("div", _hoisted_67, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_blockAndStreet",
                            modelValue: _ctx.address_blockAndStreet,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.address_blockAndStreet = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_68, [
                            _createVNode("div", _hoisted_69, [
                              _createVNode(_component_ErrorMessage, { name: "address_blockAndStreet" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_70, [
                      _createVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createVNode("div", _hoisted_73, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_nameOfBuilding",
                            modelValue: _ctx.address_nameOfBuilding,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.address_nameOfBuilding = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_74, [
                            _createVNode("div", _hoisted_75, [
                              _createVNode(_component_ErrorMessage, { name: "address_nameOfBuilding" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_76, [
                      _createVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode("div", _hoisted_79, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_unitNumber",
                            modelValue: _ctx.address_unitNumber,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.address_unitNumber = $event)),
                            maxlength: "50"
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_80, [
                            _createVNode("div", _hoisted_81, [
                              _createVNode(_component_ErrorMessage, { name: "address_unitNumber" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_82, [
                      _createVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createVNode("div", _hoisted_85, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_city",
                            modelValue: _ctx.address_city,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.address_city = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_86, [
                            _createVNode("div", _hoisted_87, [
                              _createVNode(_component_ErrorMessage, { name: "address_city" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_88, [
                      _createVNode("div", _hoisted_89, [
                        _hoisted_90,
                        _createVNode("div", _hoisted_91, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "address_postalCode",
                            modelValue: _ctx.address_postalCode,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.address_postalCode = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_92, [
                            _createVNode("div", _hoisted_93, [
                              _createVNode(_component_ErrorMessage, { name: "address_postalCode" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_94, [
                      _createVNode("div", _hoisted_95, [
                        _hoisted_96,
                        _createVNode("div", _hoisted_97, [
                          _createVNode(_component_Field, {
                            name: "address_country",
                            modelValue: _ctx.address_country,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.address_country = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select",
                            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.getCities(_ctx.address_country)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countries) + " ", 1),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countries, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.country_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_98, [
                            _createVNode("div", _hoisted_99, [
                              _createVNode(_component_ErrorMessage, { name: "address_country" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_100, [
                      _createVNode("div", _hoisted_101, [
                        _hoisted_102,
                        _createVNode("div", _hoisted_103, [
                          _createVNode(_component_Field, {
                            name: "address_province",
                            modelValue: _ctx.address_province,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.address_province = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cities, (i) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: i,
                                  label: i.name,
                                  value: i.zone_id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_104, [
                            _createVNode("div", _hoisted_105, [
                              _createVNode(_component_ErrorMessage, { name: "address_province" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_106,
                  _createVNode("div", _hoisted_107, [
                    _createVNode("div", _hoisted_108, [
                      _createVNode("div", _hoisted_109, [
                        _hoisted_110,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "beneficiary_firstName",
                          modelValue: _ctx.beneficiary_firstName,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.beneficiary_firstName = $event)),
                          maxlength: "50"
                        }, null, 8, ["modelValue"]),
                        _createVNode("div", _hoisted_111, [
                          _createVNode("div", _hoisted_112, [
                            _createVNode(_component_ErrorMessage, { name: "beneficiary_firstName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_113, [
                      _createVNode("div", _hoisted_114, [
                        _hoisted_115,
                        _createVNode(_component_Field, {
                          type: "text",
                          class: "form-control form-control-solid",
                          placeholder: "",
                          name: "beneficiary_middleName",
                          modelValue: _ctx.beneficiary_middleName,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.beneficiary_middleName = $event)),
                          maxlength: "50"
                        }, null, 8, ["modelValue"]),
                        _createVNode("div", _hoisted_116, [
                          _createVNode("div", _hoisted_117, [
                            _createVNode(_component_ErrorMessage, { name: "beneficiary_middleName" })
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_118, [
                      _createVNode("div", _hoisted_119, [
                        _hoisted_120,
                        _createVNode("div", _hoisted_121, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_lastName",
                            modelValue: _ctx.beneficiary_lastName,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.beneficiary_lastName = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_122, [
                            _createVNode("div", _hoisted_123, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_lastName" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_124, [
                      _createVNode("div", _hoisted_125, [
                        _hoisted_126,
                        _createVNode("div", _hoisted_127, [
                          _createVNode(_component_Field, {
                            type: "date",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_birthday",
                            modelValue: _ctx.beneficiary_birthday,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.beneficiary_birthday = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_128, [
                            _createVNode("div", _hoisted_129, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_birthday" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_130, [
                      _createVNode("div", _hoisted_131, [
                        _hoisted_132,
                        _createVNode("div", _hoisted_133, [
                          _createVNode(_component_Field, {
                            type: "text",
                            class: "form-control form-control-solid",
                            placeholder: "",
                            name: "beneficiary_contact",
                            modelValue: _ctx.beneficiary_contact,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.beneficiary_contact = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_134, [
                            _createVNode("div", _hoisted_135, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_contact" })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_136, [
                      _createVNode("div", _hoisted_137, [
                        _hoisted_138,
                        _createVNode("div", _hoisted_139, [
                          _createVNode(_component_Field, {
                            name: "beneficiary_relationship",
                            modelValue: _ctx.beneficiary_relationship,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.beneficiary_relationship = $event)),
                            class: "form-select form-select-lg form-select-solid",
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_140,
                              _hoisted_141,
                              _hoisted_142,
                              _hoisted_143,
                              _hoisted_144,
                              _hoisted_145
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode("div", _hoisted_146, [
                            _createVNode("div", _hoisted_147, [
                              _createVNode(_component_ErrorMessage, { name: "beneficiary_relationship" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_148, [
              _createVNode("button", _hoisted_149, [
                (!_ctx.issubmitting)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "indicator-label",
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.submitRenewal()))
                    }, " Submit Auto Renewal Data "))
                  : (_openBlock(), _createBlock("span", _hoisted_150, [
                      _hoisted_151,
                      _hoisted_152
                    ]))
              ], 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 8, ["id"]))
}